import { Box, Image, Spacer, Text, useWindowDimensions } from '@jfs/ui-new'
import { useState } from 'react'
import { staticStrings } from '../../static/staticStrings'
import usePadding from '../../util/usePadding'
import { isMobileWidth } from '../../util/util'

export const RechargeAndPayBillSection = () => {
  const resPadding = usePadding()
  const [height, setHeight] = useState(0)
  const viewportWidth = useWindowDimensions()
  const isMob = isMobileWidth(viewportWidth)
  return (
    <Box align={'center'} mt={isMob ? -30 : 0} zIndex={-1}>
      <Image
        source={require('../../assets/svg/recharges-bg.svg')}
        width={'100%'}
        height={isMob ? height : height - 4}
      />
      <Box
        ph={resPadding * 1.5}
        pt={108}
        position={'absolute'}
        top={0}
        align={'center'}
        onLayout={(evt: any) => setHeight(evt?.nativeEvent?.layout?.height)}>
        <Text
          title={staticStrings.consumerRecharge}
          fontFamily={'jiotype-black'}
          fontSize={isMob ? 24 : 64}
          lineHeight={isMob ? 36 : 80}
          letterSpacing={isMob ? 0 : -2.5}
          textAlign={'center'}
          color={'WHITE'}
        />
        <Spacer size={24} />
        <Text
          title={staticStrings.consumerRechargeSubTitle}
          fontFamily={isMob ? 'jiotype-medium' : 'jiotype-light'}
          fontSize={isMob ? 14 : 24}
          lineHeight={isMob ? 20 : 40}
          letterSpacing={isMob ? 0 : -0.48}
          textAlign={'center'}
          color={'WHITE'}
          opacity={isMob ? 0.7 : 1}
        />
        <Spacer size={64} />
        <Image
          source={require('../../assets/images/recharges.png')}
          width={isMob ? '100%' : 356}
          height={isMob ? 260 : 360}
          resizeMode={'center'}
        />
      </Box>
    </Box>
  )
}
